import { render, staticRenderFns } from "./PostingCardNew.vue?vue&type=template&id=4db372fe&scoped=true"
import script from "./PostingCardNew.vue?vue&type=script&lang=ts"
export * from "./PostingCardNew.vue?vue&type=script&lang=ts"
import style0 from "./PostingCardNew.vue?vue&type=style&index=0&id=4db372fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db372fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4db372fe')) {
      api.createRecord('4db372fe', component.options)
    } else {
      api.reload('4db372fe', component.options)
    }
    module.hot.accept("./PostingCardNew.vue?vue&type=template&id=4db372fe&scoped=true", function () {
      api.rerender('4db372fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recruitings/PostingCardNew.vue"
export default component.exports